/* eslint-disable jsx-a11y/img-redundant-alt,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';

import CompareHead from '@/braun/components/molecules/CompareHead';
import CompareActions from '@/braun/components/molecules/CompareActions';
import CompareProducts from '@/braun/components/molecules/CompareProducts';

const CompareMenu = () => (
  <div className='bra-compareTray__main'>
    <CompareHead />
    <CompareActions />
    <CompareProducts />
  </div>
);

export default CompareMenu;
